var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'page-loader',
    {
      'page-loader--loading': _vm.loading
    }
  ]},[_c('transition',{attrs:{"name":"fade-out-in","mode":"out-in"}},[(_vm.loading)?_c('div',{key:"loader",staticClass:"page-loader__loader"},[_c('b-spinner',{attrs:{"label":"Loading"}})],1):_c('div',{key:"content",staticClass:"page-loader__content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }